import { Check, User, Users, UtensilsCrossed } from "lucide-react";
import React from "react";

import Avatar from "./Avatar";

const dinheiro = (v) => `R$ ${Number(v || 0).toFixed(2).replace(".", ",")}`;

// Primeiro passo do pagar: de quem é a conta que vai ser paga (dono, 24/09).
// "Só o meu" | "Escolher quem" (ex.: eu + Carla) | "A mesa toda". Os valores
// já vêm descontando o que alguém já pagou, produto a produto.
export default function PagarQuem({ conta, escolha, onEscolher, fotoDe, darkMode }) {
  const pessoas = (conta?.pessoas || []).filter((p) => p.restante > 0 || p.eu);
  const outrasDevendo = pessoas.filter((p) => !p.eu && p.restante > 0);
  const cartao = darkMode ? "bg-zinc-900 border-zinc-800" : "bg-zinc-50 border-zinc-200";
  const ativo = "border-primary ring-2 ring-primary/30";

  const Opcao = ({ id, icone: Icone, titulo, valor, desc, desabilitado }) => (
    <button
      type="button"
      disabled={desabilitado}
      onClick={() => onEscolher({ escopo: id, pessoas: id === "pessoas" ? escolha.pessoas : [] })}
      data-e2e={`pagar-${id}`}
      className={`w-full rounded-2xl border-2 px-4 py-3 flex items-center gap-3 text-left transition disabled:opacity-40 ${cartao} ${escolha.escopo === id ? ativo : ""}`}
    >
      <span className="w-10 h-10 rounded-full bg-primary/10 text-primary flex items-center justify-center shrink-0">
        <Icone className="w-5 h-5" />
      </span>
      <span className="flex-1 min-w-0">
        <span className="block font-black">{titulo}</span>
        <span className="block text-xs opacity-60">{desc}</span>
      </span>
      {valor != null ? <span className="font-black tabular-nums">{dinheiro(valor)}</span> : null}
    </button>
  );

  const alternar = (id) => {
    const ja = escolha.pessoas.includes(id);
    onEscolher({ escopo: "pessoas", pessoas: ja ? escolha.pessoas.filter((x) => x !== id) : [...escolha.pessoas, id] });
  };

  // O caixa recebeu parte da mesa "por valor", sem dizer de quem: só a mesa
  // toda desconta isso sem cobrar ninguém em dobro.
  const soMesa = Number(conta?.pago_por_valor || 0) > 0;

  return (
    <div className="space-y-2.5">
      {soMesa ? (
        <p className={`rounded-2xl text-xs px-4 py-3 ${darkMode ? "bg-amber-500/10 text-amber-300" : "bg-amber-50 text-amber-700"}`} data-e2e="pagar-so-mesa">
          O caixa já recebeu {dinheiro(conta.pago_por_valor)} desta mesa sem separar por pessoa. Aqui dá para pagar
          o que falta da mesa toda; para pagar só a sua parte, chame o atendente.
        </p>
      ) : null}
      <Opcao id="meus" icone={User} titulo="Só o meu" valor={conta?.meu_restante}
        desc="Os produtos que você pediu" desabilitado={soMesa || !(conta?.meu_restante > 0)} />
      {outrasDevendo.length && !soMesa ? (
        <Opcao id="pessoas" icone={Users} titulo="Escolher quem" desc="Você paga a sua parte e a de quem marcar" />
      ) : null}
      {escolha.escopo === "pessoas" ? (
        <div className={`rounded-2xl border px-3 py-2 ${cartao}`} data-e2e="pagar-pessoas-lista">
          {pessoas.map((p) => {
            const marcado = escolha.pessoas.includes(p.cliente_id);
            return (
              <button key={p.cliente_id} type="button" onClick={() => alternar(p.cliente_id)} disabled={!(p.restante > 0)}
                className="w-full flex items-center gap-3 py-2 disabled:opacity-40" data-e2e="pagar-pessoa">
                <span className={`w-6 h-6 rounded-md border-2 flex items-center justify-center ${marcado ? "bg-primary border-primary text-primary-foreground" : "border-zinc-400/60"}`}>
                  {marcado ? <Check className="w-4 h-4" /> : null}
                </span>
                <Avatar nome={p.nome} foto={p.foto} fotoDe={fotoDe} tamanho={30} />
                <span className="flex-1 text-left font-semibold truncate">{p.eu ? `${p.nome} (você)` : p.nome}</span>
                <span className="text-sm tabular-nums opacity-80">{p.restante > 0 ? dinheiro(p.restante) : "pago ✓"}</span>
              </button>
            );
          })}
        </div>
      ) : null}
      <Opcao id="mesa" icone={UtensilsCrossed} titulo="A mesa toda" valor={conta?.mesa_restante}
        desc="Tudo o que falta pagar na mesa" desabilitado={!(conta?.mesa_restante > 0)} />
    </div>
  );
}
